module.exports = __webpack_public_path__ + "static/media/logo_europese_vlag.8e789a66.jpg";